const zh = {
  nav: {
    home: '首页',
    category: '分类',
    about: '关于我们',
    search: '搜索视频...',
  },
  home: {
    heroTitle: '发现精彩视频世界',
    heroSubtitle: '海量高清视频内容，热门影视、短视频、综艺娱乐，随时随地畅享极致观影体验',
    heroCTA: '立即观看',
    heroSecondary: '了解更多',
    featuredTitle: '精选推荐',
    categoriesTitle: '视频分类',
    latestTitle: '最新上线',
    viewAll: '查看全部',
    watchNow: '立即播放',
    views: '次观看',
    rating: '评分',
    duration: '时长',
  },
  category: {
    title: '视频分类',
    allVideos: '全部视频',
    filterBy: '按分类筛选',
    noVideos: '暂无视频内容',
    resultCount: '共 {{count}} 个视频',
  },
  article: {
    backToList: '返回列表',
    author: '作者',
    publishDate: '发布时间',
    readTime: '阅读时长',
    relatedVideos: '相关视频',
    tags: '标签',
  },
  about: {
    title: '关于我们',
    brandTitle: '品牌介绍',
    brandDesc: '91视频网站成立于2020年，致力于为用户提供高品质的在线视频观看体验。我们聚合了来自全球的海量视频资源，涵盖影视、综艺、动漫、纪录片、音乐、体育等多个领域，让每一位用户都能在这里找到自己喜爱的内容。',
    brandMission: '我们的使命',
    brandMissionDesc: '用科技连接创作者与观众，让优质视频内容触手可及。',
    brandVision: '我们的愿景',
    brandVisionDesc: '成为中国最受欢迎的一站式高清视频平台，让每个人都能享受极致的观影乐趣。',
    reputationTitle: '用户口碑',
    contactTitle: '联系我们',
    contactSubtitle: '有任何问题或建议？欢迎随时与我们联系',
    email: '电子邮箱',
    emailValue: 'contact@91video.com',
    phone: '客服电话',
    phoneValue: '400-888-9191',
    address: '公司地址',
    addressValue: '北京市朝阳区望京科技园A座',
    workHours: '工作时间',
    workHoursValue: '周一至周日 9:00 - 21:00',
    formName: '姓名',
    formEmail: '邮箱',
    formMessage: '留言内容',
    formSubmit: '提交留言',
    formSuccess: '感谢您的留言，我们会尽快回复！',
    formError: '提交失败，请稍后重试',
    testimonial1: '这是我用过最好用的视频网站！内容丰富，画质清晰，播放流畅，强烈推荐！',
    testimonial2: '分类很全，更新也快，想看的新片基本都能找到。界面设计也很简洁美观。',
    testimonial3: '一直在用91视频网站追剧看综艺，资源很全面。客服响应也很快，体验很好。',
    user1: '张先生',
    user1Role: '资深影视爱好者',
    user2: '李女士',
    user2Role: '综艺节目忠实观众',
    user3: '王同学',
    user3Role: '在校大学生',
    statsVideos: '视频资源',
    statsUsers: '活跃用户',
    statsViews: '累计播放',
    statsRating: '用户评分',
    statVideosValue: '10万+',
    statUsersValue: '5000万+',
    statViewsValue: '100亿+',
    statRatingValue: '4.9',
  },
  footer: {
    copyright: '© 2026 91视频网站 版权所有',
    about: '关于我们',
    privacy: '隐私政策',
    terms: '服务条款',
    contact: '联系我们',
    slogan: '高清视频，精彩生活',
  },
  breadcrumb: {
    home: '首页',
    category: '视频分类',
    article: '文章详情',
    about: '关于我们',
  },
  seo: {
    homeTitle: '91视频网站-高清视频在线观看平台',
    homeDesc: '91视频网站是一个提供海量高清视频内容的在线观看平台，涵盖热门影视、短视频、综艺娱乐等多种类型。免费流畅播放各类视频资源，享受极致观影体验。',
    homeKeywords: '91视频网站,91视频网站在线观看,91视频网站免费高清,91视频网站最新资源,91视频在线播放,高清视频网站推荐,免费视频在线观看平台',
    categoryTitle: '{{category}} - 91视频网站高清在线观看',
    categoryDesc: '91视频网站{{category}}频道，提供最新最全的高清{{category}}视频资源。免费在线观看，流畅播放体验。',
    articleTitle: '{{title}} - 91视频网站',
    articleDesc: '{{summary}}',
    aboutTitle: '关于我们 - 91视频网站',
    aboutDesc: '了解91视频网站的品牌故事、用户口碑与联系方式。91视频网站致力于提供海量高清视频内容，涵盖热门影视、短视频、综艺娱乐等多种类型。',
    aboutKeywords: '91视频网站,关于91视频网站,视频网站推荐,高清视频平台',
  },
};

export default zh;